module.exports = __webpack_public_path__ + "img/resolvedNum.45cad084.png";